import { connect } from 'react-redux';
import { selectIsMobile } from 'redux/modules/device';
import { SEARCH } from 'constants/filter-sets';
import { filterSetFilters } from 'redux/saga/selectors';
import { decorateWith, withName } from 'helpers/decorator';
import { deepExtract } from 'helpers/deep';
import { MultiSelectFilter } from '../components/filters/MultiSelectFilter';
import { searchFilterActions } from './filters.helpers';
import { filterChanged } from './filters.saga';

const { clearFilter, setFilterEditing } = searchFilterActions;

export const mapStateToProps = (state, ownProps) => {
  const { filterName } = ownProps;

  const filters = filterSetFilters(state, SEARCH);
  const filterData = deepExtract(`${filterName}`, filters, {});
  const items = filterData.itemsById || {};
  const isSelected = filterData.filtered || false;
  const selectedItems = filterData.itemIdSelected || {};
  const selectedCount = filterData.countSelected || 0;
  const isOutOfSync = filterData.needsUpdate || false;
  const isEditing = filterData.isEditing || false;
  const sortedItems = Object.keys(selectedItems).sort();
  const selectedName = (selectedCount >= 1 && deepExtract(`${sortedItems[0]}.name`, items)) || '';

  return {
    isMobile: selectIsMobile(state),
    isSelected,
    items,
    selectedCount,
    isOutOfSync,
    selectedItems,
    selectedName,
    isEditing,
  };
};

const mapDispatchToProps = {
  onSyncFilter: filterChanged,
  onClear: clearFilter,
  onSetIsEditing: setFilterEditing,
};

export const MultiSelectFilterContainer = decorateWith(
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  withName('MultiSelectFilterContainer')
)(MultiSelectFilter);
